import type { InternalDropdownOption } from '~/components/DropdownTreeSingleSelect/types';

export function updateIsExpandedFalseRecursive(
  options: InternalDropdownOption[],
  { keepExpandedIfHasSelected }: { keepExpandedIfHasSelected?: boolean } = {},
): InternalDropdownOption[] {
  return options.map((option): InternalDropdownOption => {
    return {
      ...option,
      isExpanded: keepExpandedIfHasSelected ? option.hasSelected : false,
      children: option.children
        ? updateIsExpandedFalseRecursive(option.children, {
            keepExpandedIfHasSelected,
          })
        : undefined,
    };
  });
}
